module.exports = __webpack_public_path__ + "img/9788991197398.094e0c4e.jpg";